import { DisplayPosition } from '@/type/display-position';
// import { CnOSSUpload, componentMap as formComponentMap } from '@cainiaofe/cn-ui-m';
import { handleRequestParams } from '@/common/manager/request';
export default {
    position: [
        DisplayPosition.form,
        DisplayPosition.formDialog,
        DisplayPosition.cnArrayTable,
    ],
    title: '文件上传',
    componentName: 'CnOSSUpload',
    // component: CnOSSUpload,
    // formComponent: formComponentMap.CnOSSUpload,
    getFormItemDefaultProps: () => {
        return {
            placeholder: '请选择',
        };
    },
    formItemBeforeHandler: (formItem, config) => {
        const { state, formValue, urlParams } = config;
        if (formItem) {
            const componentProps = formItem['x-component-props'];
            if (componentProps) {
                const { requestConfig, uploadProps } = componentProps;
                if (requestConfig) {
                    const { url, method, serviceType, params, resultProcessFunc } = requestConfig;
                    if (url) {
                        const service = {
                            url,
                        };
                        if (serviceType === 'mokelay') {
                            service.method = 'post';
                        }
                        else if (method) {
                            service.method = method;
                        }
                        componentProps.requestConfig = service;
                        if (Array.isArray(params) && params.length > 0) {
                            const realParams = handleRequestParams(params, {
                                urlParamsDataSource: urlParams,
                                recordDataSource: formValue,
                                state,
                            });
                            if (realParams && Object.keys(realParams).length > 0) {
                                if (service.method === 'post') {
                                    service.data = realParams;
                                }
                                else {
                                    service.params = realParams;
                                }
                            }
                        }
                        if (typeof resultProcessFunc === 'function') {
                        }
                    }
                    // delete componentProps.requestConfig;
                }
                formItem['x-component-props'] = {
                    ...componentProps,
                    ...uploadProps,
                };
            }
        }
    },
    getPrototypeList: () => {
        return [
            {
                name: 'requestConfig',
                title: '上传地址',
                display: 'inline',
                setter: {
                    componentName: 'ServiceChoiceSetter',
                    props: {
                        buttonText: '选择请求API',
                        params: {
                            env: 'pre',
                            pageSize: 999,
                            // serviceType: 'HSF',
                        },
                        paramTitleDom: React.createElement("div", { className: '' }, "\u8BF7\u6C42\u53C2\u6570\u914D\u7F6E\uFF1A"),
                        responseDom: (React.createElement("div", { style: { paddingTop: '10px' } },
                            "\u8BF7\u6C42\u8FD4\u56DE\u7ED3\u679C\u7684\u6570\u636E\u7ED3\u6784\uFF1A",
                            React.createElement("a", { target: '_blank', href: 'https://alidocs.dingtalk.com/i/nodes/EGd6jK4Nvk3JlZkYDBPnWZOP0LawMmQq', rel: 'noreferrer' }, "\u6570\u636E\u7ED3\u6784\u6587\u6863"))),
                        paramSetter: {
                            componentName: 'MixedSetter',
                            props: {
                                setters: [
                                    {
                                        componentName: 'ParamSelectSetter',
                                        props: {
                                            dataKey: 'config',
                                            labelKey: 'label',
                                            valueKey: 'name',
                                            groupName: '参数列表',
                                        },
                                        title: '选择参数',
                                    },
                                    {
                                        componentName: 'StringSetter',
                                        title: '字符串',
                                    },
                                ],
                            },
                        },
                        resultProcessFuncTemplate: `function(res) {
  // 需要返回的如下的数据结构
  // return {
  //   success: true,
  //   data: [
  //     {
  //        host:"xx",
  //        key:"xx",
  //        name:"xx",
  //        ossAccessKeyId:"xx",  // 对应 OSSAccessKeyId
  //        policy:"xx",
  //        signature:"xx",
  //        expire:"xx",
  //        success_action_status:"xx",
  //     }
  //   ]
  // }
 return res;
}`,
                    },
                },
            },
            {
                name: 'limit',
                title: '最大文件上传个数',
                setter: 'NumberSetter',
            },
            {
                name: 'multiple',
                title: '支持多选文件',
                setter: 'BoolSetter',
            },
            {
                name: 'accept',
                title: '接受上传的文件类型',
                setter: {
                    componentName: 'MixedSetter',
                    props: {
                        setters: [
                            {
                                componentName: 'CnSelectSetter',
                                props: {
                                    mode: 'multiple',
                                    options: [
                                        { value: 'image/*', title: '图片（image/*）' },
                                        { value: '.png', title: 'png图片（.png）' },
                                        { value: '.jpg', title: 'jpg图片（.jpg）' },
                                        { value: '.jpeg', title: 'jpeg图片（.jpeg）' },
                                        { value: '.pdf', title: 'pdf文件（.pdf）' },
                                        { value: '.doc', title: 'doc文件（.doc）' },
                                        { value: '.zip', title: 'zip压缩文件（.zip）' },
                                        {
                                            value: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel',
                                            title: 'excel文件',
                                        },
                                        { value: 'audio/*', title: '音频（audio/*）' },
                                        { value: 'video/*', title: '视频（video/*）' },
                                    ],
                                    selectProps: {
                                        hasClear: true,
                                    },
                                },
                                title: '常用格式',
                            },
                            {
                                componentName: 'StringSetter',
                                title: '手写accept',
                            },
                        ],
                    },
                },
            },
        ];
    },
};
